// const LinkForm = () =>
//   import("@/views/linkForm/LinkForm");
//   const LinkFormList = () =>
//   import("@/views/linkForm/LinkFormList");
// const LinkFormNoteList = () =>
//   import("@/views/linkForm/LinkFormNoteList");

// export const LinkFormListRoute = {
//   path: "linkFormList",
//   component: LinkFormList,
//   meta: {
//     requiresAuth: true,
//     title: "message.ecommerce",   
//     breadcrumb: [
//       {
//         text: "Consulta de Formularios de Vinculación",
//         disabled: false,
//         href: "#"
//       }
//     ],
//       scope:["aps_broker","aps_executive"],
//   }
// };

// export const LinkFormNoteListRoute = {
//   path: "linkFormNoteList",
//   component: LinkFormNoteList,
//   meta: {
//     requiresAuth: true,
//     title: "message.ecommerce",
//     backState: "/linkForm/linkFormNoteList",
//     breadcrumb: [
//       {
//         text: "Consulta de Notas de Formulario de Vinculación",
//         disabled: false,
//         href: "#"
//       }
//     ],
//       scope:["aps_broker","aps_executive"],
//   }
// };

// // export const ResendLinkFormRoute = {
// //   path: "ResendLinkForm",
// //   component: ResendLinkForm,
// //   meta: {
// //     requiresAuth: true,
// //     title: "message.ecommerce",
// //     backState: "/linkForm/resendLinkForm",
// //     breadcrumb: [
// //       {
// //         text: "Reenvío de Formulario de Vinculación",
// //         disabled: false,
// //         href: "#"
// //       }
// //     ],
// //       scope:["aps_broker","aps_executive"],
// //   }
// // };

// // export const UrlLinkFormRoute = {
// //   path: "UrlLinkForm",
// //   component: UrlLinkForm,
// //   meta: {
// //     requiresAuth: true,
// //     title: "message.ecommerce",
// //     backState: "/linkForm/urlLinkForm",
// //     breadcrumb: [
// //       {
// //         text: "Url de Formulario de Vinculación",
// //         disabled: false,
// //         href: "#"
// //       }
// //     ],
// //       scope:["aps_broker","aps_executive"],
// //   }
// // };

// export const LinkFormRoute = {
//   path: "linkForm",
//   component: LinkForm,
//   redirect: '/linkForm/linkFormList',
//   children: [
//     LinkFormListRoute,
//     LinkFormNoteListRoute,
//     // ResendLinkFormRoute,
//     // UrlLinkFormRoute
//   ]
// }


const LinkForm = () =>
  import("@/views/linkForm/LinkForm");

export const LinkFormRoute = {
  path: "/linkForm",
  component: LinkForm,
  meta: {
      requiresAuth: true,
      title: "message.ecommerce",
      scope:["aps_broker","aps_executive"],
      breadcrumb: [
      {
          text: "",
          disabled: false,
          href: "#"
      }]
  }
};